import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ElementRef,
  Inject,
  LOCALE_ID
} from '@angular/core';

import {
  LetterOnBoard,
  LetterToBoardService
} from '@schoolbelle/api/letter-to-board';
import { GroupService } from '@schoolbelle/api/group';
import { GroupMemberService, GroupMember } from '@schoolbelle/api/group-member';
import { BoardService } from '@schoolbelle/api/board';
import { SurveyG3Service } from '@schoolbelle/api/survey-g3';
import { SurveyV5Service } from '@schoolbelle/api/survey-v5';
import { SURVEY_FRONT_HOST } from '@schoolbelle/api/tokens';
import { AuthService } from '@schoolbelle/api/auth';
import { calculateDaysLeft } from '@schoolbelle/shared/pipes';
import { LoadingService } from '@schoolbelle/common/loading';
import { TranslationService } from '@schoolbelle/common/translation';

import { iif, of } from 'rxjs';
import { map, tap, share, switchMap } from 'rxjs/operators';
import {
  forEach,
  mapValues,
  pickBy,
  identity,
  flatten,
  sortBy,
  uniqBy
} from 'lodash-es';
import { HttpParams } from '@angular/common/http';
import { BadgeService } from '@schoolbelle/api/badge';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-letter-survey-button',
  templateUrl: './letter-survey-button.component.html',
  styleUrls: ['./letter-survey-button.component.css']
})
export class LetterSurveyButtonComponent implements OnInit {
  @Input() item: LetterOnBoard;
  deadline: number;
  daysleft: number;
  timeleft: number;
  get obsolete() {
    return this.item.deadline < Date.now();
  }
  // answered:boolean;
  members: GroupMember[] = [];
  get hasSurvey(): boolean {
    return (this.item.survey_id_g3 &&
      this.item.survey_id_g3.split(':')[0] !== 'submit') ||
      this.item.survey_id ||
      this.item.questionnaire_id
      ? true
      : false;
  }
  get hasSubmit(): boolean {
    return (
      this.item.survey_id_g3 &&
      this.item.survey_id_g3.split(':')[0] === 'submit'
    );
  }
  constructor(
    public group: GroupService,
    protected badge: BadgeService,
    protected member: GroupMemberService,
    protected survey: SurveyG3Service,
    protected surveyV5: SurveyV5Service,
    protected board: BoardService,
    protected ltb: LetterToBoardService,
    protected auth: AuthService,
    protected loading: LoadingService,
    protected translation: TranslationService,
    protected cdRef: ChangeDetectorRef,
    protected elementRef: ElementRef,
    @Inject(SURVEY_FRONT_HOST) protected survey_host: string,
    @Inject(LOCALE_ID) protected locale_id: string,
    protected i18n: I18n
  ) {}
  ngOnInit() {
    if (this.hasSurvey || this.hasSubmit) {
      this.deadline = this.item.deadline;
      this.timeleft = this.item.deadline - Date.now();
      if (this.deadline && this.deadline < Date.now()) this.daysleft = -1;
      else
        this.daysleft = this.deadline
          ? calculateDaysLeft(this.deadline)
          : Infinity;

      if (this.group.currentGroup) {
        const prefix =
          this.item.type === 'facultynews' ||
          (this.item.scopes && this.item.scopes.includes('faculty'))
            ? 'faculty_'
            : 'studentparent_';

        let members = flatten(
          this.item.targets.map(t => {
            return this.member.getMine(
              t.scopes,
              t.group_id,
              prefix
              // this.auth.currentUser.phone_number
            );
          })
        )
          .map(m => {
            if (m.member_type === 'parent')
              return this.member.mine.find(
                li => li.member_id === m.student_member_id
              );
            else return m;
          })
          .filter(m => m.member_type !== 'parent');

        members = uniqBy(members, 'member_id');

        members = sortBy(members, m => m.member_num, 'asc');
        this.members = members;
      }
    }
  }
  hasAnswered(member: GroupMember): boolean {
    return this.item.replies &&
      this.item.replies.find(r => {
        if (this.item.survey_id_g3) {
          return (<string>r.as).includes(this.survey.turnMemberIntoAs(member));
        } else {
          return (
            's' + r.student_id === member.member_id ||
            r.reply_for === member.member_id
          );
        }
      })
      ? true
      : false;
  }
  openReplyModal(member: GroupMember) {
    const group_id = this.item.group_id;
    const _as = this.survey.turnMemberIntoAs(member);
    const tags = encodeURIComponent(
      this.group.currentGroup.grade_name ||
        this.group.currentGroup.name.split(' ')[0]
    );

    if (this.item.survey_id_g3) {
      of(null)
        .pipe(
          switchMap(() => {
            switch (this.auth.tokenInfo.type) {
              case 'default':
                return of({});
              case 'temp':
                return this.auth.getAccessToken().pipe(
                  map(access_token => {
                    const id_token = this.auth.tokenInfo.id_token;
                    const expires_in = this.auth.tokenInfo.expires_in;
                    return { id_token, expires_in, access_token };
                  })
                );
              case 'code':
                return of(JSON.parse(this.auth.tokenInfo.refresh_token));
            }
          })
        )
        .subscribe(queryParams => {
          const query = new HttpParams({
            fromObject: mapValues(
              pickBy(
                {
                  survey_id: this.item.survey_id_g3,
                  group_id,
                  as: _as,
                  tags: tags,
                  ...queryParams
                },
                identity
              ),
              v => '' + v
            )
          }).toString();

          const url = `${this.survey_host}/participant?${query}`;
          window.open(url, '_blank');
        });
    } else if (this.item.survey_id) {
      this.auth.getOldTypeAccessToken().subscribe(access_token => {
        const confirmed = confirm('설문에 응답하시겠습니까?');
        if (confirmed) {
          const student_id = member.member_id.replace(/\D/g, '');
          window.open(
            `https://v2.schoolbell-e.com/survey/1.2.7/#/root/survey/${
              this.item.survey_id
            }/front/upfront?token=${access_token}${
              student_id ? '&reply_for=' + student_id : ''
            }`,
            '_blank'
          );
        }
      });
    } else {
      this.auth.getOldTypeAccessToken().subscribe(access_token => {
        const confirmed = confirm(
          '현재 웹사이트는 구버전 설문을 지원하지 않습니다. 구버전 웹사이트으로 접속하시겠습니까?'
        );
        if (confirmed) {
          window.open(
            `https://v2.schoolbell-e.com/2.5.7/#/main/group/${group_id}/schoolnews?token=${access_token}`,
            '_blank'
          );
        }
      });
    }
  }

  openStatisticsModal(confirmText?: string) {
    const group_id = this.item.group_id;
    const letter_id = this.item.letter_id;
    if (this.item.survey_id_g3) {
      iif(
        () => this.auth.rememberme,
        of(null),
        this.auth.getAccessToken()
      ).subscribe(access_token => {
        const confirmed = confirm(confirmText);
        if (confirmed) {
          const query = new HttpParams({
            fromObject: mapValues(
              pickBy(
                {
                  survey_id: this.item.survey_id_g3,
                  group_id,
                  letter_id,
                  access_token,
                  id_token: access_token ? this.auth.tokenInfo.id_token : null,
                  expires_in: access_token
                    ? this.auth.tokenInfo.expires_in
                    : null
                },
                identity
              ),
              v => '' + v
            )
          }).toString();
          // console.debug(`${this.survey_host}/statistics/charts?${query}`);
          window.open(
            `${this.survey_host}/statistics/charts?${query}`,
            '_blank'
          );
        }
      });
    }
    // else if (this.item.survey_id) {
    //   this.auth.getOldTypeAccessToken().subscribe((access_token)=>{
    //     const confirmed = confirm(this.i18n('Are you sure to open the result page?'));
    //     if (confirmed) {
    //       window.open(`https://v2.schoolbell-e.com/survey/1.2.7/#/root/survey/${this.item.survey_id}/back/charts?token=${access_token}&letter_id=${letter_id}`, '_blank');
    //     }
    //   })
    // }
    // else if (this.item.questionnaire_id) {
    //   this.auth.getOldTypeAccessToken().subscribe((access_token)=>{
    //     const confirmed = confirm('현재 웹사이트는 구버전 설문을 지원하지 않습니다. 구버전 웹사이트으로 접속하시겠습니까?');
    //     if (confirmed) {
    //       window.open(`https://v2.schoolbell-e.com/2.5.7/#/main/group/${group_id}/schoolnews?next=modal/statistics/${group_id}/${this.item.questionnaire_id}/chart&token=${access_token}`, '_blank');
    //     }
    //   })
    // }
  }
  openViewModal() {
    if (this.item.survey_id_g3) {
    } else if (this.item.survey_id) {
      window.open(
        `https://v2.schoolbell-e.com/survey/1.2.7/#/showcase/${
          this.item.survey_id
        }`,
        '_blank'
      );
    } else {
      this.auth.getOldTypeAccessToken().subscribe(access_token => {
        const confirmed = confirm(
          '현재 웹사이트는 구버전 설문을 지원하지 않습니다. 구버전 웹사이트으로 접속하시겠습니까?'
        );
        if (confirmed) {
          window.open(
            `https://v2.schoolbell-e.com/2.5.7/#/main/home?token=${access_token}`,
            '_blank'
          );
        }
      });
    }
  }

  refreshReplyStatus() {
    const checkout = this.ltb
      .fetch({
        type: this.item.type,
        ltg_id: this.item.ltg_id
      })
      .pipe(
        map(list => list[0].replies),
        tap(replies => {
          this.item.replies = replies;
          this.cdRef.detectChanges();
        }),
        share()
      );
    this.loading.open({
      message: '응답을 반영합니다...',
      busy: checkout.subscribe()
    });
    return checkout;
  }
  ngAfterViewInit(): void {
    forEach(
      this.elementRef.nativeElement.querySelectorAll('div[translation-text]'),
      el => this.translation.set(el.id, el.attributes['translation-text'].value)
    );
    //querySelectorAll should return Array...
  }
}
